import React, { PureComponent } from 'react';
import { MessageProps } from './types';
import { Message } from '../../atoms/Message';
import { imagesExtensions } from './constants';
import { AttachedFileMessage } from '../../molecules/AttachedFileMessage';

type Props = {
  userId: string;
  index: number;
  style: React.CSSProperties;
  messages: Array<MessageProps>;
  profileImgSrc?: string;
  profileImgLabel?: string;
  isAdmin?: boolean;
  setRowHeight: (index: number, size: number) => void;
  onPressImage: (imageSrc: string, imageFilename: string) => void;
  onDownloadFile: (url: string, filename: string) => void;
};

class RowRenderer extends PureComponent<Props> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rowRef: any;

  constructor(props: Props) {
    super(props);
    this.rowRef = React.createRef();
  }

  componentDidMount() {
    const { index, setRowHeight } = this.props;
    if (this.rowRef.current) {
      setRowHeight(index, this.rowRef?.current?.clientHeight);
    }
  }

  render() {
    const {
      userId,
      index,
      style,
      messages,
      onPressImage,
      onDownloadFile,
      profileImgSrc,
      profileImgLabel,
      isAdmin,
    } = this.props;
    const msg = messages[index];

    return (
      <div style={style}>
        {msg.content !== '' ? (
          <div ref={this.rowRef}>
            {this.rowRef ? (
              <Message
                theme={userId === msg.senderId ? 'own' : 'others'}
                msg={msg.content}
                dateSent={msg.createdAt}
                profileImgSrc={profileImgSrc}
                profileImgLabel={profileImgLabel}
                isAdmin={isAdmin}
              />
            ) : (
              <Message
                theme={userId === msg.senderId ? 'own' : 'others'}
                msg={msg.content}
                dateSent={msg.createdAt}
                profileImgSrc={profileImgSrc}
                profileImgLabel={profileImgLabel}
                isAdmin={isAdmin}
              />
            )}
          </div>
        ) : (
          <div ref={this.rowRef}>
            {this.rowRef && msg.attachmentURLs.length > 0 ? (
              <>
                {msg.attachmentURLs.map((file, index) => (
                  <AttachedFileMessage
                    key={`${msg.senderId}:${file.fileName}:${index}`}
                    fileUrl={file.downloadableUrl}
                    fileName={file.fileName}
                    fileSizeInBytes={file.fileSize}
                    theme={userId === msg.senderId ? 'own' : 'others'}
                    isImage={imagesExtensions.includes(file.fileType)}
                    onClickImage={() =>
                      onPressImage(file.downloadableUrl, file.fileName)
                    }
                    dateSent={msg.createdAt}
                    onDownloadFile={() =>
                      onDownloadFile(file.downloadableUrl, file.fileName)
                    }
                    profileImgSrc={profileImgSrc}
                    profileImgLabel={profileImgLabel}
                    isAdmin={isAdmin}
                  />
                ))}
              </>
            ) : (
              <>
                {msg.attachmentURLs.map((file, index) => (
                  <AttachedFileMessage
                    key={`${msg.senderId}:${file.fileName}:${index}`}
                    fileUrl={file.downloadableUrl}
                    fileName={file.fileName}
                    fileSizeInBytes={file.fileSize}
                    theme={userId === msg.senderId ? 'own' : 'others'}
                    isImage={imagesExtensions.includes(file.fileType)}
                    onClickImage={() =>
                      onPressImage(file.downloadableUrl, file.fileName)
                    }
                    dateSent={msg.createdAt}
                    onDownloadFile={() =>
                      onDownloadFile(file.downloadableUrl, file.fileName)
                    }
                    profileImgSrc={profileImgSrc}
                    profileImgLabel={profileImgLabel}
                    isAdmin={isAdmin}
                  />
                ))}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default RowRenderer;
